import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

// import styles
import './bookingTimes.scss'

// Elements
import DropDown from '../../../shared/elements/dropDown'
import DateTime from '../../../shared/elements/datetime'
import { getRelativeDateTime } from '../../../utils/time'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Grid from '../../../shared/elements/grid'
import {ElementIcons} from '../../elements/icons'
import HelpIcon from '../../../shared/elements/helpIcon'
import {BookingTimesSectionType} from '../../../constants'

import BookingTimesWrapper from './Wrapper'
import Label from '../../elements/label'
import Icon from '../../elements/icon'
import moment from 'moment'
import Text from '../../elements/text'

const DEPARTMENTTYPE = {
  Paint: 0,
  Body: 1
}

const BookingTimesSectionTypeName = {
  Pickup: 'Pickup',
  Production: 'Production',
  Delivery: 'Delivery',
  LeadTime: 'LeadTime'
}
let isLeadTimeBoxChanged = false
class BookingTimes extends Component {
  constructor (props) {
    super(props)

    this.renderContent = this.renderContent.bind(this)
  }

  getBookingSectionTypeName (type) {
    switch (type) {
      case BookingTimesSectionType.Pickup:
        return BookingTimesSectionTypeName.Pickup
      case BookingTimesSectionType.Production:
        return BookingTimesSectionTypeName.Production
      case BookingTimesSectionType.Delivery:
        return BookingTimesSectionTypeName.Delivery
      case BookingTimesSectionType.LeadTime:
        return BookingTimesSectionTypeName.LeadTime
    }
  }

  getShopTypeName (type) {
    switch (type) {
      case DEPARTMENTTYPE.Paint:
        return 'Paint'
      case DEPARTMENTTYPE.Body:
        return 'Body'
    }
  }

  getPaintDictionaryKey (bookingTimesSectionType) {
    let from = this.props.Component
    let key
    switch (bookingTimesSectionType) {
      case BookingTimesSectionType.Pickup:
        key = from === 'OrderInspection' ? 14814 : 579
        break
      case BookingTimesSectionType.Delivery:
        key = from === 'OrderInspection' ? 14815 : 193
        break
    }
    return key
  }

  renderContent (state, setState, saveBookingTime) {
    const renderBookingTimesSection = (bookingTimesSectionType, DictionaryKey, shopSection, department) => {
      if (!shopSection) return null // If section is null, the user don´t have access

      let { Date, ValidTimes, Time, CanEdit } = shopSection
      let customDate = window.CustomDate(Date)
      let disabled = !CanEdit || state.isLoading
      let inputProps = {
        readOnly: true,
        disabled: disabled
      }

      const onChange = (e) => {
        let bookingSectionName = this.getBookingSectionTypeName(bookingTimesSectionType)
        let obj = this.getShopTypeName(department)

        let value, name, date, time
        if (e.target && e.target.name === 'Time') {
          // for time change
          name = e.target.name
          value = e.target.value
          time = value
          date = Date
        } else {
          // for date change
          value = e.format('YYYY-MM-DDTHH:mm:ss')
          name = 'Date'
          time = Time
          date = e.format('YYYY-MM-DDTHH:mm:ss')
        }

        setState({
          ...state,
          [obj]: {
            ...state[obj],
            [bookingSectionName]: {
              ...state[obj][bookingSectionName],
              [name]: value
            }
          },
          isLoading: true,
          EditedBookingTime: {
            Date: date,
            Time: time,
            Department: department,
            OrderId: this.props.OrderId,
            BookingTimeType: bookingTimesSectionType
          }
        }, () => saveBookingTime())
      }

      const formatTime = (time) => {
        return time.substring(0, 5)
      }

      let warningText = null
      return (
        <LabelWrapper labelText={translation(DictionaryKey)} errorText={warningText}>
          <Grid cols={[2, 1]}>
            <DateTime
              inputProps={inputProps}
              closeOnSelect
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              value={customDate}
              name='Date'
              onChange={onChange}
              disabled={disabled} />
            <DropDown name='Time' value={formatTime(Time)} onChange={onChange} disabled={disabled}>
              {ValidTimes && ValidTimes.map((val, index) => { return <option key={index} value={formatTime(val)}>{formatTime(val)}</option> })}
              {!ValidTimes && <option value={formatTime(Time)}>{formatTime(Time)}</option>}
            </DropDown>
          </Grid>
        </LabelWrapper>
      )
    }

    const renderProductionLine = (shopSection) => {
      if (!shopSection || shopSection.Date === null) return
      let momentDate = moment(shopSection.Date)
      let newDate = momentDate.format('YYYY-MM-DD') + ' ' + shopSection.Time
      let relativeTime = getRelativeDateTime(newDate)
      let productionTime = translation('13394') + ': ' + relativeTime

      return (
        <div className='productionLine'>
          <Label>{productionTime}</Label>
          <br />
        </div>
      )
    }

    const renderBodyShopLeadTime = (bookingTimesSectionType, shopSection, department) => {
      if (!shopSection || shopSection.LeadTime === null) return

      const onChange = (e) => {
        if (e.target && e.target.name === 'LeadTime') {
          let obj = this.getShopTypeName(department)
          let value = parseInt(e.target.value)
          if (isNaN(value)) {
            value = ''
          }
          let leadTime = value
          if (value === '' || value < 1 || value > 99) {
            window.toastr.error(translation('18340'), translation('216'))
            leadTime = null
          }

          isLeadTimeBoxChanged = true
          setState({
            ...state,
            [obj]: {
              ...state[obj],
              [name]: value
            },

            EditedBookingTime: {
              Department: department,
              OrderId: this.props.OrderId,
              BookingTimeType: bookingTimesSectionType,
              LeadTime: leadTime
            }
          })
        }
      }

      const onBlur = (e) => {
        if (isLeadTimeBoxChanged) {
          saveBookingTime()
        }
      }
      let name = 'LeadTime'
      return (
        <Text key={name} labelText={translation(18341)} type='text' name={name} value={Body.LeadTime} onChange={onChange} onBlur={onBlur} autoComplete='off' />
      )
    }

    const { Body, Paint } = state
    const { FromBody, FromPaint, ShowLeadTime } = this.props

    return (
      <div>
        {Body && FromBody && renderBookingTimesSection(BookingTimesSectionType.Pickup, 14827, Body.Pickup, DEPARTMENTTYPE.Body)}

        {Paint && FromPaint && renderBookingTimesSection(BookingTimesSectionType.Pickup, this.getPaintDictionaryKey(BookingTimesSectionType.Pickup), Paint.Pickup, DEPARTMENTTYPE.Paint)}
        {/* alert message */} {Paint && FromPaint && hasSubscriptionPermission(this.props.auth, 20) && this.renderAffectedAlert(Paint.Pickup, state)}
        {Paint && FromPaint && hasSubscriptionPermission(this.props.auth, 20) && renderProductionLine(Paint.Production)}
        {Paint && FromPaint && renderBookingTimesSection(BookingTimesSectionType.Delivery, this.getPaintDictionaryKey(BookingTimesSectionType.Delivery), Paint.Delivery, DEPARTMENTTYPE.Paint)}

        {Body && FromBody && hasSubscriptionPermission(this.props.auth, 20) && renderProductionLine(Body.Production)}
        {Body && FromBody && renderBookingTimesSection(BookingTimesSectionType.Delivery, 193, Body.Delivery, DEPARTMENTTYPE.Body)}
        {/* alert message */} {Body && FromBody && this.renderAffectedAlert(Body.Delivery, state)}
        {Body && FromBody && ShowLeadTime && renderBodyShopLeadTime(BookingTimesSectionType.LeadTime, Body, DEPARTMENTTYPE.Body)}
      </div>
    )
  }

  renderAffectedAlert (shopSection, state) {
    if (!shopSection || !shopSection.AffectedMessage) return
    const { AffectedAlert, AffectedInfos } = shopSection.AffectedMessage
    if (!AffectedAlert) return
    let dateStart = ''
    let dateEnd = ''
    let infoText = []

    AffectedInfos && AffectedInfos.map((val, index) => {
      if (val.AffectedTimes && val.AffectedTimes[0].DateTime) { dateStart = getRelativeDateTime(val.AffectedTimes[0].DateTime) }
      if (val.AffectedTimes && val.AffectedTimes[0].TimeSpan) { dateStart = val.AffectedTimes[0].TimeSpan }

      dateEnd = val.AffectedTimes && val.AffectedTimes[1] && val.AffectedTimes[1].DateTime
      infoText.push(translation(val.TextKey).replace('{0}', dateStart).replace('{1}', getRelativeDateTime(dateEnd)))
    })

    let relativeTime = getRelativeDateTime(AffectedAlert.AffectedTime)
    let alertMessage = translation(AffectedAlert.TextKey).replace('{0}', relativeTime)

    const renderInfoText = (item, key) => {
      return (
        <div>
          <div key={key}>{item}</div>
          <br />
        </div>
      )
    }

    return (
      <div>
        <Grid align='center' cols={['min-content', 10, 'min-content']}>
          <Icon size='s' icon={ElementIcons.Warning} />
          <span className='alert-message'>{alertMessage}</span>
          <HelpIcon helpText={infoText.map(renderInfoText)} size='s' />
        </Grid>
        <br />
      </div>
    )
  }

  render () {
    return (
      <BookingTimesWrapper OrderId={this.props.OrderId} onUpdated={this.props.onUpdated}>
        {this.renderContent}
      </BookingTimesWrapper>
    )
  }
}

BookingTimes.defaultProps = {
  FromBody: false,
  FromPaint: false,
  ShowLeadTime: false
}

BookingTimes.propTypes = {
  FromBody: PropTypes.bool.isRequired,
  FromPaint: PropTypes.bool.isRequired,
  OrderId: PropTypes.number.isRequired,
  Component: PropTypes.string,
  ShowLeadTime: PropTypes.bool.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {})(BookingTimes)



// WEBPACK FOOTER //
// ./src/app/shared/components/BookingTimes/index.js